import ErrorPayment from 'components/Patient/checkin/SecurePayment/ErrorPayment';

import { usePaymentContextApi } from '../context/PaymentContext';

const ErrorPaymentModal = ({
  message,
  description,
  title,
  isOpen = true,
  onClearError = () => {},
  onClose = () => {}
}) => {
  const { closeModal } = usePaymentContextApi();

  const handleClearError = () => {
    closeModal();
    onClearError(null);
    onClose();
  };
  return (
    <ErrorPayment
      isOpen={isOpen}
      message={message}
      description={description}
      title={title}
      onTryAgain={handleClearError}
      onClose={handleClearError}
    />
  );
};

export default ErrorPaymentModal;
